import Phaser from 'phaser';
import { TILE } from '../types';
import { fitStaticBodyToTile } from '../systems/SpriteScaling';

export type BlockKind = 'hard' | 'soft';

export class Block extends Phaser.Physics.Arcade.Sprite {
  readonly kind: BlockKind;

  constructor(scene: Phaser.Scene, col: number, row: number, kind: BlockKind) {
    const x = col * TILE + TILE / 2;
    const y = row * TILE + TILE / 2;
    const tex = kind === 'hard' ? 'tile-hard' : 'tile-soft';
    super(scene, x, y, tex);
    this.kind = kind;
    scene.add.existing(this);
    scene.physics.add.existing(this, true);
    fitStaticBodyToTile(this, TILE, TILE);
  }
}
